import styled from "styled-components";
import { ProfileIcon } from "../../../components";

const SquishedProfileIcon = styled(ProfileIcon)`
    cursor: pointer;
    z-index: ${props => 500 - (props.order || 0)};
`;

export default SquishedProfileIcon;